module.exports = __webpack_public_path__ + "img/dave-lundy.b5442068.jpg";